import { Fragment, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setFormValue } from "../../redux/slices/userspageslice";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Checkbox } from "@progress/kendo-react-inputs";
import {
  FormInput,
  FormDropDownList,
  FormTextArea,
  FormDropDownListById,
  FormCheckbox,
} from "../../forms/form-components";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { FormRegion } from "../../components/formregion";
import { formValidator } from "./userspageformvalidator";
import { List } from "../../components/list";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

const groupsItemRenderer =
  (currentTheme, onGroupCheck) => (props, item, index) => {
    return (
      <div key={item.Id} className={`list-item`}>
        <div style={{ width: 28 }}>
          <Checkbox value={item.Checked} onChange={(e) => onGroupCheck(item)} />
        </div>
        <div className="list-item-name">{item.Name}</div>
      </div>
    );
  };

export const UsersPageForm = (props) => {
  const dispatch = useDispatch();
  const currentTheme = useSelector((state) => state.currentTheme);
  const pageState = useSelector((state) => state.usersPage);
  const appearance = useSelector((state) => state.appearance);
  const updateDirtyState = props.updateDirtyState;

  const { t } = useTranslation();

  //handle is dirty
  useEffect(() => {
    updateDirtyState();
  }, [pageState.formInitialValues, pageState.formValues]);

  return (
    <Fragment>
      <Form
        validator={formValidator(pageState.mode, t)}
        key={pageState.formKey}
        initialValues={{ ...pageState.formInitialValues }}
        render={(formRenderProps) => {
          return (
            <FormElement
              horizontal={false}
              style={
                {
                  // width: 250,
                }
              }
            >
              <FormRegion className="form-region-1">
                <div className="form-group form-group-1">
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <div
                      style={{
                        flex: 1,
                        marginRight: appearance.isRightToLeft ? 0 : 16,
                        marginLeft: appearance.isRightToLeft ? 16 : 0,
                      }}
                    >
                      <Field
                        id={"Name"}
                        name={"Name"}
                        label={t("users.name")}
                        component={FormInput}
                        onChange={(e) =>
                          dispatch(setFormValue({ id: "Name", value: e.value }))
                        }
                        autoFocus={true}
                        maxLength={50}
                      />
                    </div>
                    <div style={{ marginTop: 26 }}>
                      <Field
                        id={"IsActive"}
                        name="IsActive"
                        label={t("users.active")}
                        component={FormCheckbox}
                        disabled={pageState.mode == 2}
                        onChange={(e) =>
                          dispatch(
                            setFormValue({
                              id: "IsActive",
                              value: e.target.value,
                            })
                          )
                        }
                      />
                    </div>
                  </div>
                  {pageState.mode == 1 && (
                    <Fragment>
                      <Field
                        id={"Username"}
                        name={"Username"}
                        label={t("users.username")}
                        component={FormInput}
                        onChange={(e) =>
                          dispatch(
                            setFormValue({ id: "Username", value: e.value })
                          )
                        }
                        maxLength={50}
                        autoComplete={false}
                      />
                      <Field
                        id={"Password"}
                        name={"Password"}
                        label={t("users.password")}
                        type="password"
                        component={FormInput}
                        autoComplete="new-password"
                        onChange={(e) =>
                          dispatch(
                            setFormValue({ id: "Password", value: e.value })
                          )
                        }
                        maxLength={50}
                      />
                      <Field
                        id={"PasswordConfirmed"}
                        name={"PasswordConfirmed"}
                        label={t("users.confirmed")}
                        type="password"
                        component={FormInput}
                        onChange={(e) =>
                          dispatch(
                            setFormValue({
                              id: "PasswordConfirmed",
                              value: e.value,
                            })
                          )
                        }
                        maxLength={50}
                      />
                    </Fragment>
                  )}

                  <Field
                    id={"Email"}
                    name={"Email"}
                    label={t("users.email")}
                    component={FormInput}
                    disabled={pageState.mode == 2}
                    onChange={(e) =>
                      dispatch(setFormValue({ id: "Email", value: e.value }))
                    }
                    maxLength={255}
                  />

                  <Field
                    id={"Description"}
                    name={"Description"}
                    label={t("users.description")}
                    component={FormTextArea}
                    style={{ height: 50 }}
                    onChange={(e) =>
                      dispatch(
                        setFormValue({ id: "Description", value: e.value })
                      )
                    }
                    maxLength={255}
                  />
                  <Field
                    id={"TypeId"}
                    name={"TypeId"}
                    label={t("users.type")}
                    component={FormDropDownListById}
                    data={pageState.lookups.types}
                    dataItemKey="Id"
                    textField="Title"
                    onChange={(e) => {
                      dispatch(setFormValue({ id: "TypeId", value: e.value }));
                      dispatch(setFormValue({ id: "ClientId", value: "" }));
                      formRenderProps.onChange("ClientId", { value: "" });
                    }}
                    disabled={pageState.formValues.IsSystem}
                  />
                  {(pageState.formValues.TypeId == 2 ||
                    pageState.formValues.TypeId == 3) && (
                    <Field
                      id={"ClientId"}
                      name={"ClientId"}
                      label={t("users.clientid")}
                      component={FormInput}
                      onChange={(e) =>
                        dispatch(
                          setFormValue({ id: "ClientId", value: e.value })
                        )
                      }
                      maxLength={10}
                    />
                  )}

                  <div
                    style={{
                      marginTop: 32,
                      display: "flex",
                      flexDirection: "column",
                      flex: 1,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 13,
                        color: currentTheme.inputLabelColor,
                      }}
                    >
                      {t("users.groups")}
                    </div>
                    <div style={{ flex: 1, marginTop: 2 }}>
                      <List
                        className="groups"
                        items={pageState.formValues.Groups}
                        itemRenderer={groupsItemRenderer(
                          currentTheme,
                          props.onGroupCheck
                        )}
                      />
                    </div>
                  </div>
                </div>
              </FormRegion>
            </FormElement>
          );
        }}
      />
      <style>
        {`        
                    .users-page-form .k-form
                    {          
                        /*the kendo form which is child of my form.content*/     
                        width: 100%;
                        display: flex;
                        flex: 1;
                        justify-content: space-between;
                        padding: 0 24px 12px 24px;/*keep 12px in right and bottom so that when minimizing we keep a white region to the right and bottom; also keep 8px on the left*/
                    }

                    .users-page-form .form-region-1
                    {
                        width: 100%;
                        max-width: 1000px;
                        margin-top: 20px !important;/*to override kendo first child of k-form having marginTop=0*/                     
                    }

                    .users-page-form .form-region-1 .form-group-1
                    {
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                    }
                   
                    .users-page-form > .content
                    {
                        padding: 0px;
                        background-color: transparent;
                        align-items: flex-start;
                    }

                    .users-page-form .form-region-root
                    {
                        background-color: transparent;
                    }

                    .users-page-form input.k-input, .users-page-form textarea.k-textarea, 
                    .users-page-form .k-dropdownlist .k-input-inner
                    {
                        /*make input controls have a bit more height*/
                        padding: 6px 8px;
                    }

                    .users-page-form .form-region-root .list-container.groups
                    {
                        border: 1px solid ${currentTheme.componentBorderColor};
                        border-radius: 4px;
                        margin-top: 2px;
                        flex: 1;
                        max-height: 180px;
                    }

                    .users-page-form .form-region-root .list-container.groups .list-root
                    {
                        display: flex !important;
                        flex-wrap: wrap;   
                    }

                    .users-page-form .form-region-root .list-container.groups .list-item
                    {
                        display: flex !important;
                        width: 50%;
                        overflow-x: hidden;
                    }
                `}
      </style>
    </Fragment>
  );
};
